import React from 'react';

import DashboardContentView from './DashboardContentView';
import DashboardWebsocket from './DashboardWebsocket';
import { getClientSpecificDashboardExtension } from '@helpers/clientSpecificUtils';

const DashboardContent = () => {
  return (
    <>
      {getClientSpecificDashboardExtension()}
      <DashboardWebsocket />
      <DashboardContentView />
    </>
  );
};

export default DashboardContent;
